import {chakra} from "../../_snowpack/pkg/@chakra-ui/react.js";
import Div100vh from "../../_snowpack/pkg/react-div-100vh.js";
export const Div100Vh = chakra(Div100vh);
